import { Link } from 'react-router';

import { Typography } from 'Components/Typography';

import imageDesktop from '../images/d-contact_us_hero.jpg';
import imageMobile from '../images/m-contact_us_hero.jpg';
import imageTablet from '../images/t-contact_us_hero.jpg';

export default {
  hero: {
    title: 'Questions? Find all your answers here.',
    subtitle: 'The Pros are our expert team in haircare, ',
    link: 'Send them an email',
    imageDesktop,
    imageMobile,
    imageTablet,
  },
  block2: {
    title: (
      <>
        <span>The Pros are your support team of custom haircare experts—</span>
        <span>we’re here to listen and help.</span>
      </>
    ),
    subtitle: (
      <>
        We’re available by <Link to="/faq/contact-us">email</Link> Monday-Friday, from 9:30am-6:00pm
        EST. We aim to respond to inquiries within 24 hours.
      </>
    ),
    link: 'Visit FAQs',
    availableFrom: (
      <>
        To view our most common questions, <Link to="/faq">check out our FAQs</Link>
      </>
    ),
  },
  block3: [
    [
      <Typography color="noir" paragraph variant="h2">
        Press inquiries
        <br />
      </Typography>,
      <Typography color="grey" paragraph variant="p1">
        For all press inquiries, our dedicated PR team is at the ready.
        <br />
      </Typography>,
      <a href="mailto:press@prose.com">
        <Typography bold color="noir" upperCase variant="p2">
          Reach out
        </Typography>
      </a>,
    ],
    [
      <Typography color="noir" paragraph variant="h2">
        Need something else?
      </Typography>,
      <Typography color="grey" paragraph variant="p1">
        Contact The Pros with any inquiry, and we&apos;ll direct you to the right place.
      </Typography>,
      <Link to="/faq/contact-us">
        <Typography bold color="noir" upperCase variant="p2">
          Ask away
        </Typography>
      </Link>,
    ],
  ],
};
